import { IFileSettings } from 'legacy/lut/library/dragNDrop'

import { guid } from 'core/classes/helpers/GuidHelper'
import { IQBRReportIssueAttachment } from 'partner360/components/QBR/shared/reportIssue/components/reportModal/models'

export const prepareAttachments = (filesInfo: IFileSettings[]): IQBRReportIssueAttachment[] => {
  return filesInfo.map((item) => {
    const id = guid()
    const link = URL.createObjectURL(item.file)
    return { id, link, fileName: item.file.name, file: item.file }
  })
}
